import gql from 'graphql-tag';

export const EDI_ORDERS = gql`
  query EdiOrders($params: GetEdiOrdersInput!) {
    ediOrders(params: $params) {
      nodes {
        _id
        poNumber
        filename
        status
        sentAt
        shipToName
        shipToAccount
        shipToAddress1
        shipToCity
        shipToState
        shipToZip
        lines {
          supplierItem
          buyerItem
          uom
          uomQty
          requestedEach
        }
        isaControl
        gsControl
        stControl
        createdAt
      }
      meta {
        total
        page
        limit
        totalPage
      }
    }
  }
`;

export const EDI_ORDER = gql`
  query EdiOrder($id: String!) {
    ediOrder(id: $id) {
      _id
      poNumber
      filename
      status
      sentAt
      shipToName
      shipToAccount
      shipToAddress1
      shipToCity
      shipToState
      shipToZip
      lines {
        supplierItem
        buyerItem
        uom
        uomQty
        requestedEach
      }
      createdAt
      isaControl
      gsControl
      stControl
    }
  }
`;

export const PLACE_ORDER = gql`
  mutation PlaceOrder($params: PlaceOrderInput!) {
    placeOrder(params: $params) {
      poNumber
      filename
      status
    }
  }
`;

export const SEARCH_CATALOG_PRODUCTS = gql`
  query SearchCatalogProducts($orgId: String!, $term: String, $limit: Int) {
    searchCatalogProducts(organizationId: $orgId, term: $term, limit: $limit) {
      supplierItemNumber
      itemNumber
      shortDescription
      uom
      uomToEach
      cost
    }
  }
`;

export const EDI_INBOUND_DOCS = gql`
  query InboundDocs($orgId: String!, $type: InboundType, $po: String) {
    ediInboundDocs(
      organizationId: $orgId
      type: $type
      poNumber: $po
      limit: 50
    ) {
      _id
      type
      filename
      linkedPo
      linkedPos
      error
      parsedJson
      createdAt
    }
  }
`;

export const EDI_INSIGHTS_DASHBOARD = gql`
  query EdiInsightsDashboard($params: EdiInsightsDashboardInput!) {
    ediInsightsDashboard(params: $params) {
      isAllOrganizations
      scopedOrganizationId
      scopedOrganizationName
      startDate
      endDate
      trendGroupBy
      summary {
        totalOrders
        totalRequestedUnits
        avgLinesPerOrder
        totalSent
        totalFailed
        totalAckAccepted
        totalAckRejected
        totalShipped
        totalInvoiced
        ordersWithErrors
        totalInboundDocs
        totalAckDocs
        totalShipmentDocs
        totalInvoiceDocs
        shipmentRecords
        shipmentRecordsWithTracking
        uniqueTrackingNumbers
        totalInvoices
        totalInvoiceAmount
        averageInvoiceAmount
      }
      statusBreakdown {
        status
        count
      }
      orderTrend {
        period
        orderCount
        requestedUnits
      }
      invoiceTrend {
        period
        invoiceCount
        invoiceAmount
      }
      ackCodeBreakdown {
        code
        description
        count
      }
      topSkus {
        supplierItem
        buyerItem
        description
        orderCount
        lineCount
        requestedUnits
      }
      topShipToAccounts {
        account
        name
        orderCount
        requestedUnits
      }
      topShipToLocations {
        city
        state
        orderCount
        requestedUnits
      }
      topCarriers {
        carrier
        count
      }
      organizationBreakdown {
        organizationId
        organizationName
        totalOrders
        totalRequestedUnits
        totalFailed
        totalAckRejected
        totalInvoiced
        totalInvoiceAmount
        failureRate
        rejectionRate
      }
      recentOrders {
        _id
        poNumber
        filename
        status
        shipToName
        shipToAccount
        shipToCity
        shipToState
        createdAt
        sentAt
        lastError
      }
      recentInboundDocs {
        _id
        type
        filename
        linkedPo
        linkedPos
        error
        createdAt
      }
    }
  }
`;
